(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('CompositeDetailController', CompositeDetailController);

    CompositeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Composite', 'Compendium', 'BillingFrequency', 'Clinic'];

    function CompositeDetailController($scope, $rootScope, $stateParams, previousState, entity, Composite, Compendium, BillingFrequency, Clinic) {
        var vm = this;

        vm.composite = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:compositeUpdate', function(event, result) {
            vm.composite = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
